import { trackSwapVariantTestBuyArticle } from "@coworker/app/src/helpers/tracker";
import { Testbuy } from "../../services/testbuy.service";
import { TestBuyProductWithCriteria } from "@coworker/types/lib/testbuy";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { useTranslation } from "react-i18next";
import {
  ProductVariant,
  useItemVariants,
} from "@coworker/apprestructured/src/shared/hooks/item/useItemVariants";

interface ChangeVariantButtonProps {
  testbuy: Testbuy;
  article: TestBuyProductWithCriteria;
  area: string;
  onOpenVariant?: (variants: ProductVariant[]) => void;
}

export const ChangeVariantButton = ({
  testbuy,
  article,
  area,
  onOpenVariant,
}: ChangeVariantButtonProps) => {
  const { t } = useTranslation();
  const { data: variants = [], isLoading } = useItemVariants(article.shortId);

  // Event handlers
  const handleChangeWithClick = () => {
    trackSwapVariantTestBuyArticle(testbuy.strategy, article.shortId, area);
    onOpenVariant?.(variants);
  };

  const hasVariables = variants.length > 0;
  const hasSizes = variants.some(({ size }) => !!size);

  const description = hasVariables
    ? [t("colorString"), hasSizes && t("sizeString").toLowerCase()]
        .filter(Boolean)
        .join(", ")
    : t("noVariantsString");

  if (!article.id) return null;
  return (
    <FixaListViewItem
      title={t("productVariantsString")}
      description={description}
      control="navigational"
      controlIcon="chevronRight"
      onClick={handleChangeWithClick}
      disabled={isLoading || !hasVariables}
      emphasised
    />
  );
};
